import React from "react"
import { createGlobalStyle } from "styled-components"

import GlobalFonts from "../../assets/fonts/"
import tokens from "../_tokens"
import SkipLink from "./skip-link"

const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    font-family: ${tokens.font.base};
    font-size: ${tokens.fontSize.base};
    line-height: 1.5;
    color: ${tokens.color.text.base};
  }`

function wrapPageElement({ element }) {
  return (
    <>
      <GlobalStyles />
      <GlobalFonts />
      <SkipLink />
      {element}
    </>
  )
}

export default wrapPageElement
